<template>
  <section class="notifications">
    <template v-if="notifications.length">
      <template v-for="notification in notifications">
        <b-notification @close="close(notification)" :key="notification.id" :type="`is-${notification.type}`">
          <div v-html="notification.message"></div>
        </b-notification>
      </template>
    </template>
  </section>
</template>

<script lang="js">
import bus from './bus.js'
export default  {
  name: 'notifications',
  props: [],
  data() {
    return {
      notifications: []
    }
  },
  methods: {
    close(notification) {
      if(notification.onClose) {
        notification.onClose(notification.id)
      }
      const index = this.$lodash.findIndex(this.notifications, {id: notification.id})
      if(~index)
        this.notifications.splice(index, 1)
    },
    addNotification(notification) {
      if(!notification.id) {
        notification.id = this.$lodash.uniqueId('notification_')
      }
      this.notifications.push(notification);
      if(notification.timeout !== Infinity) {
        setTimeout(()=>{
          const index = this.$lodash.findIndex(this.notifications, {id: notification.id})
          if(~index)
            this.notifications.splice(index, 1)
        }, (notification.timeout  * 1000) || 5000)
      }
    }
  },
  mounted() {
    bus.$on('notify', this.addNotification)
  },
  beforeDestroy() {
    bus.$off('notify', this.addNotification)
  }
}
</script>

<style scoped lang="scss">
.list-enter-active,
.list-leave-active {
  transition: opacity 1s ease-out, transform 1s ease-out;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.notifications {
  z-index: 100;
  position: fixed;
  top: calc(52px + 0.75rem + 0.6rem);
  right: 2rem;

  .notification {
    padding: 1rem 2rem 1rem 1rem;
    margin-bottom: 0.75rem;
  }
}
</style>
